import { type FC } from 'react';
import cn from 'classnames';
import { Image } from '@direct-frontend/components';
import { type CompanyLogoProps } from './lib/types';
import { getRequestContext, getSafeUserRequestContext } from '../../lib/context';
import { getCompanyLogoSrc, getStaticImageUrl } from '../../lib/images';
import { checkIsYCPBrand } from '../../lib/ycp';
import styles from './CompanyLogo.module.css';

export const CompanyLogo: FC<CompanyLogoProps> = ({ width, height, className, theme = 'light', ...imageProps }) => {
    const requestContext = getRequestContext();
    const logoSrc = getStaticImageUrl(
        getCompanyLogoSrc({
            env: requestContext.env,
            isInternalYandexUser: getSafeUserRequestContext().isInternalYandexUser,
            isYCP: checkIsYCPBrand(),
            theme,
        })
    );

    return (
        <Image {...imageProps} className={cn(className, styles.image)} width={width} height={height} src={logoSrc} />
    );
};
